import { makeStyles, tokens } from '@fluentui/react-components';

export const useInsightsSummarizeMessageStyles = makeStyles({
  pluginResult: {
    marginBottom: tokens.spacingVerticalXL,
    '& .positive': {
      color: tokens.colorPaletteGreenBackground3,
    },
    '& .negative': {
      color: '#BC4B09', // red
    },
  },
});
